export function contentVersion(version, t) {
  if (typeof version !== "string" || !version.trim()) return t("laufzeit.unbekannt");
  return /^(active|draft)$/i.test(version.trim()) ? t("laufzeit.entwurf") : version.trim();
}

export function deploymentDate(value, locale) {
  if (value == null || value === "") return null;
  const text = String(value);
  const odata = text.match(/^\/Date\((-?\d+)(?:[+-]\d{4})?\)\/$/);
  const numeric = /^-?\d+$/.test(text);
  // SAP Edm.DateTime deployment values without an offset represent UTC.
  const isoText = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(text) ? `${text}Z` : text;
  const timestamp = odata ? Number(odata[1]) : numeric ? Number(text) : Date.parse(isoText);
  // SAP returns zero when there is no deployment timestamp.
  if (!Number.isFinite(timestamp) || timestamp <= 0) return null;
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return null;
  return { iso: date.toISOString(), label: date.toLocaleString(locale, {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  }) };
}

export function contentRuntimeDisplay(flow, inventory, t, locale) {
  const designVersion = contentVersion(flow.Version, t);
  if (inventory.status !== "ready") {
    const label = t(inventory.status === "error" ? "laufzeit.nichtGeladen" : "laufzeit.laedt");
    return { designVersion, runtimeVersion: label, deployed: label, state: inventory.status };
  }
  const runtime = inventory.byId.get(flow.Id);
  if (!runtime) return { designVersion, runtimeVersion: t("laufzeit.nichtDeployed"), deployed: t("laufzeit.nichtDeployed"), state: "absent" };
  const date = deploymentDate(runtime.DeployedOn, locale);
  const different = !!flow.Version && !!runtime.Version && flow.Version !== runtime.Version && !/^(active|draft)$/i.test(flow.Version);
  return { designVersion, runtimeVersion: contentVersion(runtime.Version, t),
    deployed: date?.label || t("laufzeit.datumFehlt"), date, different, state: "present" };
}
